const FN_PRINT_GRID = {
  offsetY: 3.2,
  headlineMargin: 8,
  notesMargin: 8,
  line: 10,
  columns: [
    60,
    132,
    204,
    276,
    348,
    420,
    492,
    564,
    636,
    708
  ],
};

export default FN_PRINT_GRID;
